import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const LMApi = createApi({
  reducerPath: 'LMApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.PUBLIC_URL}/api/lm`
  }),
  tagTypes: ['LmByggnad', 'LmFastighetBeteckning'],
  endpoints: () => ({})
});
